import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';

export default function AuthGuard({ children }) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitialized) return;

    if (!isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized) return null;

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };